/* Retro Reflections - copy edit mode.
   Dormant unless the URL carries ?edit=1, so customers never see it.
   Lets you click any text on the page, retype it, and keep the result.
   Edits are stored in this browser only - nothing is published until
   you send the change list back and it is applied to the theme. */
(function () {
  'use strict';
  if (!/[?&]edit=1\b/.test(location.search)) return;

  var KEY = 'rr-edits:' + location.pathname;
  var SKIP = /^(SCRIPT|STYLE|SVG|PATH|IMG|INPUT|TEXTAREA|SELECT|OPTION|CANVAS|IFRAME|NOSCRIPT)$/;
  var edits = {};
  var on = false;

  try { edits = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { edits = {}; }

  /* ---------- a stable address for each element ---------- */
  function pathOf(el) {
    var parts = [];
    while (el && el.nodeType === 1 && el !== document.body) {
      var p = el.parentNode, i = 1, s = p ? p.firstElementChild : null;
      while (s && s !== el) { if (s.tagName === el.tagName) i++; s = s.nextElementSibling; }
      parts.unshift(el.tagName.toLowerCase() + ':' + i);
      el = p;
    }
    return parts.join('>');
  }
  function bySel(path) {
    var el = document.body;
    var parts = path.split('>');
    for (var k = 0; k < parts.length && el; k++) {
      var bits = parts[k].split(':'), tag = bits[0].toUpperCase(), n = +bits[1], i = 0, c = el.firstElementChild;
      el = null;
      while (c) { if (c.tagName === tag && ++i === n) { el = c; break; } c = c.nextElementSibling; }
    }
    return el;
  }

  /* ---------- which elements are text we can edit ---------- */
  function editable(el) {
    if (!el || el.nodeType !== 1 || SKIP.test(el.tagName)) return false;
    if (el.closest('#rr-bar')) return false;
    var hasText = false, hasBlockKid = false, c;
    for (c = el.firstChild; c; c = c.nextSibling) {
      if (c.nodeType === 3 && c.nodeValue.trim()) hasText = true;
      if (c.nodeType === 1 && !SKIP.test(c.tagName)) {
        var d = getComputedStyle(c).display;
        if (d === 'block' || d === 'flex' || d === 'grid' || d === 'list-item' || d === 'table') hasBlockKid = true;
      }
    }
    return hasText && !hasBlockKid;
  }

  function label(el) {
    var t = el.tagName.toLowerCase();
    var names = { h1: 'Heading', h2: 'Heading', h3: 'Sub-heading', h4: 'Sub-heading',
                  p: 'Paragraph', li: 'List item', a: 'Link', button: 'Button', span: 'Label', strong: 'Bold text', em: 'Emphasis' };
    var base = names[t] || 'Text';
    var sec = el.closest('section,footer,header,div[id]');
    var id = sec && sec.id ? sec.id : '';
    return id ? base + ' in "' + id + '"' : base;
  }

  /* ---------- apply / collect ---------- */
  function restore() {
    Object.keys(edits).forEach(function (p) {
      var el = bySel(p);
      if (el) el.textContent = edits[p].now;
    });
    paint();
  }

  function record(el) {
    var p = pathOf(el), now = el.textContent.replace(/\s+/g, ' ').trim();
    if (edits[p]) {
      if (now === edits[p].was) delete edits[p];
      else edits[p].now = now;
    } else {
      var was = (el.getAttribute('data-rr-was') || '').replace(/\s+/g, ' ').trim();
      if (now !== was) edits[p] = { was: was, now: now, what: label(el) };
    }
    try { localStorage.setItem(KEY, JSON.stringify(edits)); } catch (e) {}
    paint();
  }

  /* ---------- edit mode on/off ---------- */
  function arm(yes) {
    on = yes;
    document.body.classList.toggle('rr-editing', yes);
    var all = document.body.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (!editable(el)) continue;
      if (yes) {
        if (!el.hasAttribute('data-rr-was')) el.setAttribute('data-rr-was', el.textContent);
        el.setAttribute('contenteditable', 'plaintext-only');
        el.classList.add('rr-can-edit');
      } else {
        el.removeAttribute('contenteditable');
        el.classList.remove('rr-can-edit');
      }
    }
    paint();
  }

  /* ---------- the toolbar ---------- */
  var bar, count, msg;
  function paint() {
    if (!count) return;
    var n = Object.keys(edits).length;
    count.textContent = n === 0 ? 'No changes yet' : n + (n === 1 ? ' change' : ' changes');
    bar.querySelector('#rr-toggle').textContent = on ? 'Editing - click text' : 'Start editing';
    bar.querySelector('#rr-toggle').style.background = on ? '#C9A972' : '#141C2E';
    bar.querySelector('#rr-toggle').style.color = on ? '#141C2E' : '#F3E7D6';
  }
  function flash(t) { msg.textContent = t; setTimeout(function () { msg.textContent = ''; }, 3000); }

  function report() {
    var keys = Object.keys(edits);
    var out = ['RETRO REFLECTIONS - copy changes',
               'Page: ' + location.pathname,
               'Changes: ' + keys.length, ''];
    keys.forEach(function (p, i) {
      out.push((i + 1) + '. ' + edits[p].what);
      out.push('   WAS: ' + edits[p].was);
      out.push('   NOW: ' + edits[p].now);
      out.push('');
    });
    out.push('--- for Claude, do not edit below ---');
    out.push(JSON.stringify({ page: location.pathname, edits: edits }));
    return out.join('\n');
  }

  function copyText(t, okMsg) {
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = t; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); flash(okMsg); } catch (e) { flash('Could not copy - use Download instead.'); }
      document.body.removeChild(ta);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(t).then(function () { flash(okMsg); }, fallback);
    } else fallback();
  }

  function build() {
    var css = document.createElement('style');
    css.textContent =
      '#rr-bar{position:fixed;right:18px;bottom:18px;z-index:2147483000;background:#141C2E;color:#F3E7D6;' +
      'font-family:Inter,system-ui,sans-serif;font-size:13px;font-weight:300;padding:14px 16px;width:250px;' +
      'box-shadow:0 8px 30px rgba(0,0,0,.28);border:1px solid rgba(201,169,114,.5)}' +
      '#rr-bar h6{margin:0 0 3px;font-family:Georgia,serif;font-weight:400;font-size:15px;color:#C9A972;letter-spacing:.02em}' +
      '#rr-bar .rr-n{font-size:11.5px;color:#9BA4B4;margin-bottom:11px}' +
      '#rr-bar button{display:block;width:100%;margin-bottom:7px;padding:9px 10px;border:1px solid rgba(201,169,114,.55);' +
      'background:transparent;color:#F3E7D6;font-family:inherit;font-size:12.5px;cursor:pointer}' +
      '#rr-bar button:hover{background:rgba(201,169,114,.16)}' +
      '#rr-bar #rr-toggle{background:#141C2E;font-size:13px;padding:11px 10px;margin-bottom:10px}' +
      '#rr-bar .rr-msg{font-size:11.5px;color:#C9A972;min-height:15px;line-height:1.4;margin-top:2px}' +
      '#rr-bar .rr-tip{font-size:11px;color:#7E879A;line-height:1.5;margin-top:8px;border-top:1px solid rgba(255,255,255,.12);padding-top:8px}' +
      'body.rr-editing .rr-can-edit{outline:1px dashed rgba(168,135,92,.55);outline-offset:2px;cursor:text}' +
      'body.rr-editing .rr-can-edit:hover{outline-color:#A8875C;background:rgba(201,169,114,.10)}' +
      'body.rr-editing .rr-can-edit:focus{outline:2px solid #A8875C;background:rgba(201,169,114,.16)}' +
      'body.rr-editing a{pointer-events:none}body.rr-editing #rr-bar a{pointer-events:auto}';
    document.head.appendChild(css);

    bar = document.createElement('div');
    bar.id = 'rr-bar';
    bar.innerHTML =
      '<h6>Copy edit mode</h6>' +
      '<div class="rr-n" id="rr-count">No changes yet</div>' +
      '<button id="rr-toggle">Start editing</button>' +
      '<button id="rr-copy">Copy my changes</button>' +
      '<button id="rr-dl">Download as a file</button>' +
      '<button id="rr-reset">Undo everything</button>' +
      '<div class="rr-msg" id="rr-msg"></div>' +
      '<div class="rr-tip">Links are disabled while editing. Turn editing off to click through to another page - add <b>?edit=1</b> to its address to edit there too.</div>';
    document.body.appendChild(bar);
    count = bar.querySelector('#rr-count');
    msg = bar.querySelector('#rr-msg');

    bar.querySelector('#rr-toggle').onclick = function () { arm(!on); };
    bar.querySelector('#rr-copy').onclick = function () {
      if (!Object.keys(edits).length) return flash('Nothing changed yet.');
      copyText(report(), 'Copied - paste it back to Claude.');
    };
    bar.querySelector('#rr-dl').onclick = function () {
      if (!Object.keys(edits).length) return flash('Nothing changed yet.');
      var b = new Blob([report()], { type: 'text/plain' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(b);
      a.download = 'retro-copy-changes' + location.pathname.replace(/\//g, '-') + '.txt';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      flash('Downloaded.');
    };
    bar.querySelector('#rr-reset').onclick = function () {
      if (!confirm('Undo every change on this page and go back to the original wording?')) return;
      Object.keys(edits).forEach(function (p) { var el = bySel(p); if (el) el.textContent = edits[p].was; });
      edits = {};
      try { localStorage.removeItem(KEY); } catch (e) {}
      flash('Back to the original.');
      paint();
    };

    document.addEventListener('focusout', function (e) {
      if (on && e.target && e.target.classList && e.target.classList.contains('rr-can-edit')) record(e.target);
    }, true);
    document.addEventListener('keydown', function (e) {
      if (on && e.key === 'Escape' && document.activeElement) document.activeElement.blur();
    });
  }

  function boot() { build(); restore(); arm(true); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
